import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { StripePlugin } from '@vue-stripe/vue-stripe'
import {createApp} from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vuelidate from '@vuelidate/core';
import Vidle from 'v-idle-3';
import App from "./App.vue";
import VuePaginate from 'vue-paginate';
import Vue3Geolocation from 'vue3-geolocation';
import SimpleTypeahead from 'vue3-simple-typeahead';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

const appl = createApp(App);
appl.component('EasyDataTable', Vue3EasyDataTable);
appl.mount("#app");
appl.use(Toast, { timeout: false });
appl.use(Vuelidate);
appl.use(Vidle);
appl.use(VuePaginate);
appl.use(Vue3Geolocation);
appl.use(SimpleTypeahead);